import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AccessProvider } from '@/features/AccessProvider';
import { AdminShell, AdvertiserShell } from '@/components/layout/AppShell';

import { LoginPage } from '@/pages/auth/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

import { DashboardPage } from '@/pages/advertiser/DashboardPage';
import { CampaignsPage } from '@/pages/advertiser/CampaignsPage';
import { CampaignDetailPage } from '@/pages/advertiser/CampaignDetailPage';
import { BookAdsPage } from '@/pages/advertiser/BookAdsPage';
import { BookingDetailPage } from '@/pages/advertiser/BookingDetailPage';
import { WalletPage } from '@/pages/advertiser/WalletPage';
import { InvoicesPage } from '@/pages/advertiser/InvoicesPage';
import { ReportsPage } from '@/pages/advertiser/ReportsPage';

import { AdminOverviewPage } from '@/pages/admin/AdminOverviewPage';
import { ApprovalsPage } from '@/pages/admin/ApprovalsPage';
import { AdvertisersPage } from '@/pages/admin/AdvertisersPage';
import { AdvertiserDetailPage } from '@/pages/admin/AdvertiserDetailPage';
import { AdminBookingsPage } from '@/pages/admin/AdminBookingsPage';
import { RateCardPage } from '@/pages/admin/RateCardPage';
import { InventoryPage } from '@/pages/admin/InventoryPage';
import { AdminReportsPage } from '@/pages/admin/AdminReportsPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Advertiser self-serve area */}
      <Route
        element={
          <ProtectedRoute area="advertiser">
            <AdvertiserShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="/book" element={<BookAdsPage />} />
        <Route path="/bookings/:id" element={<BookingDetailPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/reports" element={<ReportsPage />} />
      </Route>

      {/* Internal admin area */}
      <Route
        element={
          <ProtectedRoute area="admin">
            <AccessProvider>
              <AdminShell />
            </AccessProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/admin" element={<AdminOverviewPage />} />
        <Route path="/admin/approvals" element={<ApprovalsPage />} />
        <Route path="/admin/advertisers" element={<AdvertisersPage />} />
        <Route path="/admin/advertisers/:id" element={<AdvertiserDetailPage />} />
        <Route path="/admin/bookings" element={<AdminBookingsPage />} />
        <Route path="/admin/rate-card" element={<RateCardPage />} />
        <Route path="/admin/inventory" element={<InventoryPage />} />
        <Route path="/admin/reports" element={<AdminReportsPage />} />
      </Route>

      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
